import { render } from "./UpdateZonePage.vue?vue&type=template&id=4b144838&ts=true"
import script from "./UpdateZonePage.vue?vue&type=script&lang=ts"
export * from "./UpdateZonePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Zones/UpdateZonePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b144838"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b144838', __exports__)) {
    api.reload('4b144838', __exports__)
  }
  
  module.hot.accept("./UpdateZonePage.vue?vue&type=template&id=4b144838&ts=true", () => {
    api.rerender('4b144838', render)
  })

}


export default __exports__